import CalendarOutlined from '@ant-design/icons/CalendarOutlined';

const icons = { CalendarOutlined };

// 캘린더 — 사건 마감 + 사용자 메모 통합 일정 (docs/13-calendar-design.md).
const calendar = {
  id: 'group-calendar',
  title: '일정',
  type: 'group',
  children: [
    {
      id: 'calendar',
      title: '캘린더',
      type: 'item',
      url: '/calendar',
      icon: icons.CalendarOutlined,
      breadcrumbs: false
    }
  ]
};

export default calendar;
